import React from 'react';
import './footer.css';
import {
  FaFacebookF, FaLinkedinIn, FaInstagram, FaXTwitter,
  FaLocationDot, FaPhone, FaEnvelope
} from "react-icons/fa6";
import { Link } from 'react-router-dom';
import footerLogo from '../assets/images/footer_logo_new.png';

const Footer = () => {
  return (
    <footer className="footer-modern">
      <div className="footer-container">
        {/* Column 1: Logo + Desc */}
        {/* Column 1: Logo + Desc */}
<div className="footer-section brand">
  <img src={footerLogo} alt="Footer Logo" className="footer-logo" />

  <p className="tagline">
    At Vanshika Micro Credit, we are reimagining lending for salaried professionals.
  </p>

  <p className="desc">
    We believe financial support should be quick, simple, and transparent.
    With fast approvals, instant disbursals, and fully clear terms,
    we make sure your financial needs never have to wait.
  </p>

  {/* Social Icons BELOW text, LEFT aligned */}
  <div className="social-icons left-social">
    <a href="https://www.facebook.com/people/Dhanwalle-Con/pfbid036z3oBddMu2JtFYMnGUX9XRGYo55X6AnpH7kUHq7m9QPoXEwrmN6U3z8c8hrV8pwHl/?rdid=XX6Fm698LkTTBcVG&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F17EYQFzWSE%2F">
      <FaFacebookF />
    </a>
    <a href="https://www.linkedin.com/in/dhanwalle-finance-1925b2386/">
      <FaLinkedinIn />
    </a>
    <a href="https://www.instagram.com/dhanwalle/">
      <FaInstagram />
    </a>
    <a href="https://x.com/dhanwalle91938">
      <FaXTwitter />
    </a>
  </div>
</div>


        {/* Column 2: Quick Links */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            {[
              ['Apply Loan', 'apply-now'],
              ['Contact Us', 'contact-us'],
              ['Corporate Governance', 'corporate-governance'],
              ['Fair Practice Code', 'fair-practice-code'],
              ['Interest Rate Policy', 'interest-rate-policy'],
              ['Risk Management Policy', 'risk-management-policy'],
              // ['Career', 'career'],
            ].map(([label, path]) => (
              <li key={label}><Link to={`/${path}`}>{label}</Link></li>
            ))}
          </ul>
        </div>

        {/* Column 3: Resources */}
        <div className="footer-section">
          <h4>Resources</h4>
          <ul>
            {[
              ['Terms and Conditions', 'terms-conditions'],
              ['Privacy Policy', 'privacy-policy'],
              ['Key Fact Statement', 'key-fact-statement'],
              ['KYC and PMLA', 'kyc-and-pmla'],
              ['Terms & Rates', 'terms-rates'],
              ['FAQs', 'faqs'],
            ].map(([label, path]) => (
              <li key={label}><Link to={`/${path}`}>{label}</Link></li>
            ))}
          </ul>
        </div>

        {/* Column 4: Contact + Social Icons */}
        <div className="footer-section contact">
          <h4>Contact</h4>
          <p style={{ color: 'white' }}>
  <FaLocationDot className="icon" /> Registered Office: VO-656 AT WE WORK BERGER ONE, SECTOR16B, C-001/A2, Gautam Buddha Nagar, Noida, Uttar Pradesh, 201301
</p>

<p style={{ color: 'white' }}>
  <FaLocationDot className="icon" /> Corporate Office: 11th, 1111, Surya Kiran Building Gate, Kasturba Gandhi Marg, Connaught Place, New Delhi, Central Delhi, Delhi, 110001.
</p>

          <p><FaEnvelope className="icon" /> <a href="mailto:info@dhanwalle.com">info@dhanwalle.com</a></p>
          <p><FaPhone className="icon" /> <a href="tel:+919211460800">+91-9211460800</a></p>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
  <p style={{ color: 'white', fontSize: '14px' }}>&copy; 2025 Vanshika Micro Credit. All Rights Reserved.</p>
</div>

    </footer>
  );
};

export default Footer;
